// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateOrganizationCommissionRuleDTO
 */
export interface UpdateOrganizationCommissionRuleDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationCommissionRuleDTO
     */
    commissionRule: UpdateOrganizationCommissionRuleDTOCommissionRuleEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateOrganizationCommissionRuleDTOCommissionRuleEnum {
    FEEPERCENTAGE12POINT5 = 'FEE_PERCENTAGE_12_POINT_5',
    FEEPERCENTAGE15 = 'FEE_PERCENTAGE_15',
    FEEPERCENTAGE20 = 'FEE_PERCENTAGE_20',
    NOCOMMISSION = 'NO_COMMISSION'
}



